






































import Vue from "vue";
import { Routes } from "@/router/Routes";
import { mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";
import { PermissionKeys } from "@/types";
import CommonButton from "@/views/academy/common/CommonButton.vue";

export default Vue.extend({
  name: "ExpiredSubscriptionNotification",
  components: { CommonButton },
  props: { show: { required: true } },
  methods: {
    redirectToBilling() {
      if (this.$route.params.orgId) {
        this.$router.push(
          `/${this.$route.params.orgId}/subscriptions/licenses`
        );
      } else {
        this.$router.push(`/subscriptions/signup`);
      }
    }
  },
  computed: {
    ...mapGetters({
      hasPermission: GetterTypes.GET_COACH_HAS_PERMISSION,
      message: GetterTypes.GET_ORG_SUBSCRIPTION_STATUS_MESSAGE
    }),
    canEditBillingInfo(): boolean {
      return this.hasPermission(PermissionKeys.CAN_EDIT_BILLING);
    }
  }
});
